import { axios } from "../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useGeneralAppStore } from "../store/generalAppStore";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

//TODO genera el PDF de Aviso de Visita
export const generarAvisoDeVisita = async (id) => {
  handlerLoading({ loading: true, loadName: "generar_aviso" });
  try {
    const response = await axios().post("/get_aviso_visita", { id: id });
    const { data, error } = response.data;
    // console.log(data)
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "generar_aviso" });
  }
};

//TRAE EL DETALLE DE UN ACTA
export const getActaDetalle = async (acta) => {
  try {
    handlerLoading({ loading: true, loadName: "acta_detalle" });
    const response = await axios().get(
      acta?.estado_id == 3 ? `acta_a_chequear/${acta?.id}` : `acta/${acta?.id}`
    );
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error(error, toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "acta_detalle" });
  }
};

//REVISION DEL CONTROL DEL ACTA
export const controlActaDetalle = async (payload) => {
  try {
    handlerLoading({ loading: true, loadName: "control_acta" });
    const response = await axios().post("control_acta_detalle", payload);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error(error, toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "control_acta" });
  }
};

export const refreshControl = async (payload) => {
  try {
    const response = await axios().post("control_acta_detalle", payload);
  } catch (error) {
    toast.error(error, toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "control_acta" });
  }
};


export const descargarActasImprimir = async (dataSend) => {
  try {
    handlerLoading({ loading: true, loadName: "descargar_actas" });
    const response = await axios().post("descargar_actas", dataSend);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error(error, toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "descargar_actas" });
  }
};

const getActaChequear = async (dataSend) => {
  handlerLoading({ loading: true, loadName: "acta_detalle" });
  const response = await axios().get(`acta_a_chequear/${dataSend}`);
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      // setActaDetalle(data);
      setAllActaDetalle(data);
      // setActasDetalle(data);
      handlerModal({ modal: true, modalName: "acta_detalle" });
    }
    if (!data && error) {
      toast.error(error, toastOptions);
    }
  } else {
    toast.error("Hubo un error en la consulta", toastOptions);
  }
  handlerLoading({ loading: false, loadName: "acta_detalle" });
};
